export const baseUri = 'users';
export const byConfirmationTokenUri = 'by-confirmation-token';
export const confirmInviteUri = 'confirm-invite';
